import replaceCharactersWithX from '@th/shared/src/helpers/sanitization/replaceCharactersWithX';

export default function blurText(string: string, isBlurred: boolean) {
  return isBlurred && Boolean(string) ? replaceCharactersWithX(string) : string;
}
